export default "__VITE_ASSET__vZAazE0d__"